var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMmsProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 39.0024C9.02322 39.0024 8 38.0111 8 36.788V23.5017C8 19.8389 11.0763 16.8586 14.8571 16.8586C18.638 16.8586 21.7143 19.8389 21.7143 23.5017V30.1449C21.7143 31.3658 22.7397 32.3593 24 32.3593C25.2603 32.3593 26.2857 31.3658 26.2857 30.1449V25.7161C26.2857 22.0532 29.362 19.073 33.1429 19.073C36.9237 19.073 40 22.0532 40 25.7161V32.3593C40 33.5824 38.9768 34.5736 37.7143 34.5736C36.4518 34.5736 35.4286 33.5824 35.4286 32.3593V25.7161C35.4286 24.4952 34.4031 23.5017 33.1429 23.5017C31.8826 23.5017 30.8571 24.4952 30.8571 25.7161V30.1449C30.8571 33.8077 27.7809 36.788 24 36.788C20.2191 36.788 17.1429 33.8077 17.1429 30.1449V23.5017C17.1429 22.2808 16.1174 21.2874 14.8571 21.2874C13.5969 21.2874 12.5714 22.2808 12.5714 23.5017V36.788C12.5714 38.0111 11.5482 39.0024 10.2857 39.0024ZM11.4291 11.3221C11.4291 13.1562 12.964 14.6442 14.8582 14.6442C16.7525 14.6442 18.2874 13.1573 18.2874 11.3221C18.2874 9.48693 16.7525 8 14.8582 8C12.964 8 11.4291 9.48693 11.4291 11.3221ZM29.7148 13.5365C29.7148 15.3706 31.2497 16.8586 33.144 16.8586C35.0382 16.8586 36.5731 15.3717 36.5731 13.5365C36.5731 11.7013 35.0382 10.2144 33.144 10.2144C31.2497 10.2144 29.7148 11.7013 29.7148 13.5365Z",
    fill: "url(#paint0_linear_3575_32391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3575_32391",
    x1: 4.82889,
    y1: 33.9188,
    x2: 35.6059,
    y2: 14.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1B70FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmsProfile);
export default __webpack_public_path__ + "static/media/mms-profile.46bf2c75f391aa5ef676e861d057c9e2.svg";
export { ForwardRef as ReactComponent };